var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListCommon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.0002 3C10.4158 3 10.7502 3.33437 10.7502 3.75V8.65312L14.8565 6.1125C15.2096 5.89375 15.6721 6.00312 15.8877 6.35625C16.1033 6.70937 15.9971 7.17188 15.644 7.3875L11.4252 10L15.644 12.6125C15.9971 12.8313 16.1033 13.2937 15.8877 13.6438C15.6721 13.9938 15.2065 14.1031 14.8565 13.8875L10.7502 11.3469V16.25C10.7502 16.6656 10.4158 17 10.0002 17C9.58459 17 9.25022 16.6656 9.25022 16.25V11.3469L5.14397 13.8875C4.79085 14.1062 4.32835 13.9969 4.11272 13.6438C3.8971 13.2906 4.00335 12.8281 4.35647 12.6125L8.57522 10L4.35647 7.3875C4.00335 7.16875 3.89397 6.70625 4.11272 6.35625C4.33147 6.00625 4.79397 5.89375 5.14397 6.1125L9.25022 8.65312V3.75C9.25022 3.33437 9.58459 3 10.0002 3Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgListCommon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "52784f8080309e3a398bccc4baecf208.svg";